class CartNotification extends HTMLElement {
  private notification: HTMLElement;
  private header: StickyHeaderElement | null;
  private onBodyClick: (evt: MouseEvent) => void;
  private activeElement: HTMLElement | null = null;
  private cartItemKey = '';

  constructor() {
    super();

    this.notification = document.getElementById('cart-notification')!;
    this.header = document.querySelector<StickyHeaderElement>('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open(): void {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick as EventListener);
  }

  close(): void {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick as EventListener);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState: { key: string; sections: Record<string, string> }): void {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id)!.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender(): { id: string; selector?: string }[] {
    console.log('getSectionsToRender cart-notif');
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
    ];
  }

  getSectionInnerHTML(html: string, selector = '.shopify-section'): string {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)!.innerHTML;
  }

  handleBodyClick(evt: MouseEvent): void {
    const target = evt.target as Element;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element: HTMLElement | null): void {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
